import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DatastoreUserTaxOptOutReasonsModule } from '@freelancer/datastore/collections';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { RevertTaxOptOutModalComponent } from './revert-tax-opt-out-modal.component';

@NgModule({
  imports: [
    CommonModule,
    DatastoreUserTaxOptOutReasonsModule,
    UiModule,
    TrackingModule,
  ],
  declarations: [RevertTaxOptOutModalComponent],
})
export class RevertTaxOptOutModalModule {}
